import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type AppState from "cc-frontend/services/app-state"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"

export interface FullScreenModalArgs {
  course: Course
  planbook: Planbook
  rotationCalendar: RotationCalendar
  dateString: string
  editCourseTitleAndOrder: Function
}

export default class FullScreenComponent extends Component {
  // Args
  model!: FullScreenModalArgs

  // State
  isFullScreen: boolean = true

  // Services
  @service("ember-store") store!: EmberStore
  @service appState!: AppState
  @service modalManager!: ModalManager
}
